/**
 * Self servis fişi (Printer2 / print-js) için sepet satırlarını dönüştürür.
 * CartOrder.PlaceOrder ile aynı kurallar; kampanya sonrası güncel cartEntries kullanılmalı.
 */

export function setBillExtras(extras) {
  const list = extras || [];
  const returnObj = [];
  list.forEach((x) => {
    if (x.quantity > 0) {
      returnObj.push(x);
    } else if (x.quantity === 0 && x.variants != null && x.variants.length > 0) {
      x.variants.filter((y) => y.quantity > 0).forEach((z) => {
        returnObj.push(z);
      });
    }
  });
  return returnObj;
}

export function sumOfExtraPrices(extras) {
  let sum = 0;
  (extras || []).forEach((x) => {
    if (x.variants != null && x.variants.length > 0) {
      x.variants.forEach((y) => {
        sum += y.price * y.quantity;
      });
    } else {
      sum += x.price * x.quantity;
    }
  });
  return sum;
}

/**
 * @param {Array} entries cloneCurrentCart.cartEntries
 * @returns {Array} Printer2 orderEntries şekli
 */
export function buildOrderBillEntriesFromCartEntries(entries) {
  if (!entries || !entries.length) return [];
  const rows = [];
  entries.forEach((tr, idx) => {
    const steps = tr.recipe && tr.recipe.steps ? tr.recipe.steps : [];
    const qty = tr.quantity || 1;
    const unitBase = qty ? tr.price / qty : 0;
    const originUnitBase = qty ? ((Number(tr.originPrice) > 0 ? Number(tr.originPrice) : Number(tr.price)) / qty) : 0;
    rows.push({
      id: tr.id != null ? tr.id : tr.rowId != null ? tr.rowId : `bill-line-${idx}`,
      productId: tr.productId,
      childProductId: tr.childProductId,
      productQuantity: tr.quantity,
      productName: tr.productName,
      recipe: tr.recipe,
      variantItems: steps.filter(
        (x) => x.selected === true && x.isDefault === false
      ),
      extras: setBillExtras(tr.extras || []),
      price: unitBase - sumOfExtraPrices(tr.extras || []),
      originPrice: originUnitBase - sumOfExtraPrices(tr.extras || []),
    });
  });
  return rows;
}
